import { render, staticRenderFns } from "./Kommunikationsangaben.vue?vue&type=template&id=1a4627ee"
import script from "./Kommunikationsangaben.vue?vue&type=script&lang=js"
export * from "./Kommunikationsangaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports